import React from 'react';

export const SaveIcon = ({ width = 33, height = 32, color = "#001C8E", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 33 32"
            fill="none"
        >
            <path
                className={className}
                d="M9.83333 25.3333V17.3333H23.1667V25.3333H25.8333V10.4373L22.0627 6.66667H7.16667V25.3333H9.83333ZM5.83333 4H23.1667L28.5 9.33333V26.6667C28.5 27.0203 28.3595 27.3594 28.1095 27.6095C27.8594 27.8595 27.5203 28 27.1667 28H5.83333C5.47971 28 5.14057 27.8595 4.89052 27.6095C4.64048 27.3594 4.5 27.0203 4.5 26.6667V5.33333C4.5 4.97971 4.64048 4.64057 4.89052 4.39052C5.14057 4.14048 5.47971 4 5.83333 4ZM12.5 20V25.3333H20.5V20H12.5Z"
                fill={color}
            />
        </svg>
    );
};